import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { useTheme } from "@/components/ThemeProvider"
import { createPortal } from "react-dom"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  // Portalled to <body>: #root is `isolation: isolate` (website-base.css, for the particle background), which would
  // trap the toaster's z-index below every Radix sheet and dialog, themselves portalled to <body>.
  return createPortal(
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
          // A modal Radix layer sets pointer-events: none on <body>; toasts stay dismissable over it.
          pointerEvents: "auto",
        } as React.CSSProperties
      }
      {...props}
    />,
    document.body,
  )
}

export { Toaster }
